import { render, staticRenderFns } from "./custom-form-item.vue?vue&type=template&id=0b703a35&scoped=true&"
import script from "./custom-form-item.vue?vue&type=script&lang=js&"
export * from "./custom-form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b703a35",
  null
  
)

export default component.exports